module.exports = __webpack_public_path__ + "images/exposer-954e026153d7424e463a65bccc4006ac.png";